import React, { useEffect, useState } from "react";
import Header from "../../components/header/header";
import ContactUs, { companyLink } from "../../components/ContactUs/ContactUs";
import {
  backendUrl,
  CONTACT_US_TRIGER,
  GOLD_QUANTITY_LIST,
  MESSAGE_TYPE,
  PRODUCT_GOLD_TYPE,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD,
} from "../../constants";
import Currency from "../../components/currency/currency";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import {
  getStripeCards,
  getStripeSubscriptionAction,
  manualPaymentAction,
  setPaymentMethodSelection,
  setPaymentSteps,
  setQuantity,
  setTripleaUrl,
  subscriptionPlan,
} from "../../actions/stripe";
import { userBidGoldPriceLockAction } from "../../actions/user";
import toast from "react-hot-toast";
import { getSingleSubscriptonPlan } from "../../actions/subscriptionPlan";
import ContentLoader from "react-content-loader";
import { isMobile } from "react-device-detect";
import { sendMessageToAdmin } from "../../actions/chat";
import { sendMessageToAdminChat } from "../../actions/chatv2";

export default function ProductPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const planId = location?.pathname?.split("/").pop();
  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const [loader, setLoader] = useState(false)
  const [activeSegment, setActiveSegment] = useState(1)

  const {
    stripeSubscription,
    stripePlans,
    stripeModal,
    paymentMethodSelection,
    stripeType
  } = useSelector((state) => state.stripe);
  const { selectedPlanProduct, selectedPlanProductCurrentPage, planLoader } = useSelector((state) => state.subscriptionPlanProducts);
  const { selectedCompany } = useSelector((state) => state.company);
  const { subscriptions } = useSelector((state) => state.stripe);

  useEffect(() => {
    getPlanById();
    dispatch(getStripeCards());
  }, [location]);

  useEffect(() => {
    const { id } = selectedCompany;
    if (id) {
      dispatch(getStripeSubscriptionAction(id, 1, 2000));
    }
  }, [selectedCompany])

  const getPlanById = async () => {
    const { id } = selectedCompany;
    if (planId) {
      var resp = await dispatch(getSingleSubscriptonPlan(id, planId, selectedPlanProductCurrentPage, location));
      if (!resp?.status) {
        navigate(RoutesPaths.PRODUCTS_LIST_PAGE);
      }
    } else {
      navigate(RoutesPaths.PRODUCTS_LIST_PAGE);
    }
  };

  useEffect(() => {
    if (stripePlans && stripePlans?.supportedPaymentMethod?.length > 0) {
      dispatch(setPaymentMethodSelection(paymentMethodSelection ? paymentMethodSelection : stripePlans?.supportedPaymentMethod[0]?.value));
    }
  }, [stripePlans, selectedPlanProduct]);

  const forwardPaymentPage = async () => {
    if ((stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN)) {
      setLoader(true);
      let message = `I am interested to receive a quote for ${companyLink(selectedCompany)} under the ${stripePlans?.name}`;
      await sendMessageToAdminChat(message, selectedCompany, MESSAGE_TYPE.CONTACT_US_BUTTON, navigate, [])
      setLoader(false);
    } else {
      setLoader(true);
      if (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS) {
        dispatch(manualPaymentAction(stripePlans?.price))
      } else {
        dispatch(manualPaymentAction(0))
      }
      dispatch(setQuantity(GOLD_QUANTITY_LIST[0]))
      dispatch(setPaymentSteps(1));
      dispatch(setTripleaUrl(null, false))
      if (pathnames[0] == "dashboard") {
        navigate(RoutesPaths.DASHBOARD_BANKTRANSFER.replace(":slug", planId));
      } else if (pathnames[0] == "book-of-business") {
        navigate(RoutesPaths.BOOK_OF_BUSINESS_BANKTRANSFER.replace(":slug", planId));
      } else {
        navigate(RoutesPaths.BANKTRANSFER.replace(":slug", planId));
      }
      setLoader(false);
    }
  };
  const segmentArray = [
    { label: "Key features", value: 1 },
    { label: "Highlights", value: 2 }
  ]

  const handleSegment = (value) => {
    setActiveSegment(value)
  }
  return (
    <>
      <Header title="Product" subtitle="Product" mobileHeader={planId} />

      <div className="container-fluid minHeightVH py-4 paymentPage paddingBottomMD">
        {planLoader ? (
          <div className="row">
            <div className="col-12 col-md-4">
              <ContentLoader width={"100%"} height={164}>
                <rect rx="5" ry="5" width={"100%"} height="164" />
              </ContentLoader>
              <div className="row mt-2">
                <div className="col-md-4">
                  <ContentLoader width={"100%"} height={30}>
                    <rect rx="5" ry="5" width={"100%"} height={50} />
                  </ContentLoader>
                </div>
              </div>
              <div className="row mt-2">
                {[1, 2, 3].map((item, index) => (
                  <div key={index} className="col-md-4">
                    <ContentLoader width={"100%"} height={50}>
                      <rect rx="5" ry="5" width={"100%"} height={50} />
                    </ContentLoader>
                  </div>
                ))}
              </div>
              <div className="row mt-4">
                {[1, 2].map((item, index) => (
                  <div key={index} className="col-md-6">
                    <ContentLoader width={"100%"} height={50}>
                      <rect rx="5" ry="5" width={"100%"} height={50} />
                    </ContentLoader>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 col-md-8">
              {[
                100, 90, 80, 70, 80, 75, 65, 60, 50, 55, 60, 90, 65, 70, 80,
              ].map((item, index) => (
                <ContentLoader key={index} width={item + "%"} height={15}>
                  <rect rx="5" ry="5" width={item + "%"} height="15" />
                </ContentLoader>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="productPlanCta">
                  <div className="productImageHolder">
                    <div className="productImage" style={{ backgroundImage: `url(${backendUrl + stripePlans?.mobileImage?.filename})` }}></div>
                  </div>
                  <div className="choosePaymentMethod">
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          disabled={
                            loader ||
                            subscriptions?.some(
                              (x) =>
                                x.subscriptionPlan?._id === selectedPlanProduct?.id &&
                                [SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN, SUBSCRIPTION_MODULE_TYPE.PLAN].includes(parseInt(x?.subscriptionModuleType)) &&
                                x?.payment_status !== "expired"
                            )
                          }
                          onClick={forwardPaymentPage}
                          className="productUpgradePlanBtn">
                          {loader && (
                            <i className="animateSpin fa-solid fa-circle-notch"></i>
                          )}
                          {(stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN) ? "Receive a quote" : stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL ? "Deposit paid-up capital" : stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS ? "Add capital" : "Buy product"}
                        </button>
                      </div>
                      <div className="col-6">
                        <ContactUs
                          name="Learn more"
                          theme="planContactUS"
                          subscriptionPlanName={stripePlans?.name}
                          type={stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL ? CONTACT_US_TRIGER.PAID_UP_CAPITAL_PAYMENT : CONTACT_US_TRIGER.PAYMENT}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="productPlanHolder">
                  <div className="productPlanPriceHolder">
                    <h4 className="productplanTitle">
                      {stripePlans?.name || "-"}
                    </h4>
                    {(stripePlans?.planType?.value !== SUBSCRIPTION_MODULE_TYPE.PLAN && stripePlans?.planType?.value !== SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN) &&
                      <p className="recumentPrice">
                        <Currency currency={stripePlans?.currency?.value} />{" "}
                        <CurrencyFormat
                          currency={stripePlans?.currency?.value}
                          value={parseFloat(stripePlans?.price)}
                          decimal={2}
                        />*
                      </p>
                    }
                    {/* {stripePlans?.smallDescription && (
                      <p className="productSlug">
                        {stripePlans?.smallDescription}
                      </p>
                    )} */}
                    {(stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN) &&
                      <h6 className="productplanHeader">
                        Request a quote
                      </h6>
                    }
                    <p className="productplanDes">
                      {stripePlans?.description}
                    </p>
                  </div>
                  <div className="planTabsHolder">
                    {segmentArray?.map((item, index) => (
                      <div onClick={() => handleSegment(item?.value)} key={index} className={`planTabs ${item?.value === activeSegment ? 'active' : ""}`}>
                        <p>{item.label}</p>
                      </div>
                    ))}
                  </div>
                  {activeSegment === 2 &&
                    <div
                      className="planDescription"
                      dangerouslySetInnerHTML={{
                        __html: stripePlans?.targetAudience || "-",
                      }}></div>
                  }
                  {activeSegment === 1 &&
                    <div className="row top-section">
                      {stripePlans?.assuredFeature &&
                        stripePlans?.assuredFeature?.length > 0 && (
                          <div className="col-md-6">
                            <h6 className="BottomBankPlantitle">
                              You are assured of:
                            </h6>
                            {stripePlans?.assuredFeature?.map((item, index) => (
                              <div key={index} className="youAreAssignReceive">
                                <img src="assets/img/assuerdIcon.svg" alt="" />
                                <p>{item}</p>
                              </div>
                            ))}
                          </div>
                        )}

                      {stripePlans?.guarentedFeature &&
                        stripePlans?.guarentedFeature?.length > 0 && (
                          <div className="col-md-6">
                            <h6 className="BottomBankPlantitle">
                              You are guaranteed to receive:
                            </h6>
                            {stripePlans?.guarentedFeature?.map((item, index) => (
                              <div key={index} className="youAreAssignReceive">
                                <img src="assets/img/assuerdIcon.svg" alt="" />
                                <p>{item}</p>
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  }
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
